/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentEditorsDiscountTypes200,
  GetApiV1IndividualpaymentEditorsDiscountTypes401,
  GetApiV1IndividualpaymentEditorsDiscountTypes500,
  GetApiV1IndividualpaymentEditorsDiscountTypesQueryParams,
  GetApiV1IndividualpaymentEditorsDiscountTypesQueryResponse,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsDiscountTypes.ts";
import { individualPaymentDiscountTypeViewModelSchema } from "../individualPaymentDiscountTypeViewModelSchema.ts";

export const getApiV1IndividualpaymentEditorsDiscountTypesQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentEditorsDiscountTypes200Schema = z.array(
  z.lazy(() => individualPaymentDiscountTypeViewModelSchema),
) as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypes200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentEditorsDiscountTypes401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypes401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentEditorsDiscountTypes500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypes500>;

export const getApiV1IndividualpaymentEditorsDiscountTypesQueryResponseSchema =
  z.lazy(
    () => getApiV1IndividualpaymentEditorsDiscountTypes200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypesQueryResponse>;
